import styled from '@emotion/styled'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import 'bootstrap/dist/css/bootstrap.min.css'
import { jwtDecode } from 'jwt-decode'
import { useMemo } from 'react'
import { ToastContainer } from 'react-toastify'
import './assets/theme.css'
import catchError from './components/global/CatchError'
import Router from './components/global/Router'
import UserContext from './context/UserContext'
import { MenuProvider } from './context/MenuContext'
import './i18n/translation'
import { DecodedToken, UserContextType } from './types/user.type'

function App() {
    let tokenAdmin: string = ''
    let tokenMember: string = ''
    let tokenCoach: string = ''
    let decodedTokenAdmin: DecodedToken | undefined
    let decodedTokenMember: DecodedToken | undefined
    let decodedTokenCoach: DecodedToken | undefined

    try {
        tokenAdmin = localStorage.getItem('tokenAdmin') ?? ''
        decodedTokenAdmin = tokenAdmin ? jwtDecode(tokenAdmin) : undefined
        tokenMember = localStorage.getItem('tokenMember') ?? ''
        decodedTokenMember = tokenMember ? jwtDecode(tokenMember) : undefined
        tokenCoach = localStorage.getItem('tokenCoach') ?? ''
        decodedTokenCoach = tokenCoach ? jwtDecode(tokenCoach) : undefined
    } catch (err) {
        console.error('Erreur lors du décodage des tokens:', err)
        catchError({ status: 401, message: 'Votre session a expiré' }, () => {
            localStorage.removeItem('tokenAdmin')
            localStorage.removeItem('tokenMember')
            localStorage.removeItem('tokenCoach')
            window.location.reload()
        })
    }

    const user: UserContextType = useMemo(
        () => ({
            tokenAdmin,
            adminData: decodedTokenAdmin,
            tokenMember,
            memberData: decodedTokenMember,
            tokenCoach,
            coachData: decodedTokenCoach,
        }),
        [tokenAdmin, tokenMember, decodedTokenAdmin, decodedTokenMember, tokenCoach, decodedTokenCoach]
    )

    return (
        <UserContext.Provider value={user}>
            <MenuProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MainContainer>
                        <Router />
                        <ToastContainer />
                    </MainContainer>
                </LocalizationProvider>
            </MenuProvider>
        </UserContext.Provider>
    )
}

const MainContainer = styled.div`
    background: var(--main-bg-color);
    min-height: 100vh;
`

export default App
